var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Year", prop: "year" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "value-format": "yyyy",
                                        type: "year",
                                        placeholder: "选择年",
                                      },
                                      model: {
                                        value: _vm.queryCondition.year,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "year",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.year",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Sponsor",
                                      prop: "sponsorName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.sponsorName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "sponsorName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.sponsorName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Category3",
                                      prop: "category3Code",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.category3Code,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "category3Code",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.category3Code",
                                        },
                                      },
                                      _vm._l(
                                        _vm.category3List,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.object,
                                              value: item.key,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "ASL", prop: "aslName" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.aslName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "aslName",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.aslName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryData(1)
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROT_3P_ADD,
                    expression: "RMC_PROT_3P_ADD",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.addList },
              },
              [_vm._v("新增")]
            ),
            _c(
              "el-dropdown",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROT_3P_EXPORT,
                    expression: "RMC_PROT_3P_EXPORT",
                  },
                ],
                staticStyle: { "margin-right": "10px" },
                attrs: {
                  "split-button": "",
                  type: "primary",
                  placement: "bottom",
                },
                on: { click: _vm.handleClick },
              },
              [
                _vm._v(" 报表导出 "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "el-dropdown-item",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "dropdownItemBtn",
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.exportAslAuditReport },
                          },
                          [_vm._v("ASL审核报告")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-dropdown-item",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "dropdownItemBtn",
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.exportHistoryReport },
                          },
                          [_vm._v("历史记录")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.RMC_PROT_3P_AUDIT_DOWNLOAD,
                    expression: "RMC_PROT_3P_AUDIT_DOWNLOAD",
                  },
                ],
                staticClass: "btn",
                attrs: { type: "danger" },
                on: { click: _vm.downloadAuditReport },
              },
              [_vm._v("审核报告下载")]
            ),
          ],
          1
        ),
        _c(
          "ux-grid",
          {
            ref: "plxTable",
            attrs: {
              data: _vm.tableData,
              "max-height": "500",
              "show-overflow": "tooltip",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.selectionChange },
          },
          [
            _c("ux-table-column", {
              attrs: { align: "center", type: "checkbox", width: "80" },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Year",
                "min-width": "100",
                field: "year",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Category3",
                field: "category3Name",
                width: "120",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "Sponsor",
                "min-width": "100",
                field: "sponsorName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "ASL",
                "min-width": "120",
                field: "aslName",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "3方GMP",
                "min-width": "140",
                field: "gmp",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.goDetail(scope.row, 3)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.gmp))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "3方HACCP",
                "min-width": "100",
                field: "haccp",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "3方Antibiotics",
                "min-width": "120",
                field: "antibiotics",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "3方AnimaWalfare",
                "min-width": "120",
                field: "animalWalfare",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: `3方${_vm.customLabel}`,
                "min-width": "100",
                field: "swa",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.goDetail(scope.row, 3)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.swa))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "3方ASL审核时间",
                "min-width": "120",
                field: "aslAuditDate",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: `3方${_vm.customLabel}审核时间`,
                "min-width": "120",
                field: "swaAuditDate",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "2方GMP",
                "min-width": "120",
                field: "gmpSecond",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.goDetail(scope.row, 2)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.gmpSecond))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "2方HACCP",
                "min-width": "120",
                field: "haccpSecond",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "2方Antibiotics",
                "min-width": "120",
                field: "antibioticsSecond",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "2方AnimaWalfare",
                "min-width": "120",
                field: "animalWalfareSecond",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: `2方${_vm.customLabel}`,
                "min-width": "120",
                field: "swaSecond",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "2方ASL审核时间",
                "min-width": "120",
                field: "aslAuditDateSecond",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: `2方${_vm.customLabel}审核时间`,
                "min-width": "120",
                field: "swaAuditDateSecond",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "3方审核报告",
                "min-width": "120",
                field: "updateDate",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.openDetail(scope.row, 3)
                            },
                          },
                        },
                        [_vm._v("查看")]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "2方审核报告",
                "min-width": "120",
                field: "updateDate",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.openDetail(scope.row, 2)
                            },
                          },
                        },
                        [_vm._v("查看")]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "3方备注",
                "min-width": "120",
                field: "remark",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "2方备注",
                "min-width": "120",
                field: "remarkSecond",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "更新人",
                "min-width": "120",
                field: "submitUser",
              },
            }),
            _c("ux-table-column", {
              attrs: {
                align: "center",
                title: "更新时间",
                "min-width": "120",
                field: "submitDate",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.dialogVisible,
              width: "60%",
              "before-close": _vm.handleClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("更新状态 "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "normal",
                            "margin-left": "10px",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("如果无更新时，请先在日期后点击确认")]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c("updateDialog", { on: { close: _vm.handleClose } }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "",
              visible: _vm.fileleDialog,
              width: "60%",
              "before-close": _vm.closeFileDialog,
            },
            on: {
              "update:visible": function ($event) {
                _vm.fileleDialog = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [_vm._v("附件")]),
                  ]
                ),
              ]
            ),
            _vm.fileleDialog
              ? _c("fileleDialog", { attrs: { fileList: _vm.fileList } })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }